'use client';
import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { cn } from './utils/cn';

export const BoxesCore = ({ className, ...rest }: { className?: string }) => {
  const rows = new Array(65).fill(1);
  const cols = new Array(50).fill(1);
  let colors = [
    '--sky-300',
    '--pink-300',
    '--green-300',
    '--yellow-300',
    '--red-300',
    '--purple-300',
    '--blue-300',
    '--indigo-300',
    '--violet-300',
  ];
  const getRandomColor = () => {
    return colors[Math.floor(Math.random() * colors.length)];
  };

  useEffect(() => {
    const changeRandomBox = () => {
      const randomX = Math.floor(Math.random() * 30);
      const randomY = Math.floor(Math.random() * 40);
      var colorList = [
        '#7dd3fc',
        '#f9a8d4',
        '#86efac',
        '#fde047',
        '#fca5a5',
        '#d8b4fe',
        '#93c5fd',
        '#a5b4fc',
        '#c4b5fd',
      ];
      const randomColor =
        colorList[Math.floor(Math.random() * colorList.length)];
      const box = document.querySelector(
        `#box-${randomX}-${randomY}`
      ) as HTMLElement;
      if (box) {
        box.style.background = randomColor;
        setTimeout(() => {
          box.style.background = 'transparent';
        }, 2000);
      }
    };

    if (window.innerWidth < 850) {
      for (let i = 0; i < 20; i++) {
        setTimeout(() => {
          changeRandomBox();
        }, i * 200);
      }
      const intervalId = setInterval(() => {
        for (let i = 0; i < 20; i++) {
          setTimeout(() => {
            changeRandomBox();
          }, i * 200);
        }
      }, 2000 + 20 * 200);
      return () => clearInterval(intervalId);
    }
  }, []);

  return (
    <div
      style={{
        transform: `translate(-40%,-60%) skewX(-48deg) skewY(14deg) scale(0.675) rotate(0deg) translateZ(0)`,
      }}
      className={cn(
        'absolute left-1/4 p-4 -top-1/4 flex  -translate-x-1/2 -translate-y-1/2 w-screen h-screen z-0',
        className
      )}
      {...rest}
    >
      {rows.map((_, i) => (
        <motion.div
          key={`row` + i}
          className='w-16 h-8  border-l  border-slate-700 relative'
        >
          {cols.map((_, j) => (
            <motion.div
              whileHover={{
                backgroundColor: `var(${getRandomColor()})`,
                transition: { duration: 0 },
              }}
              animate={{
                transition: { duration: 2 },
              }}
              key={`col` + j}
              id={`box-${i}-${j}`}
              className='w-16 h-8  border-r border-t border-slate-700 relative'
            >
              {j % 2 === 0 && i % 2 === 0 ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth='1.5'
                  stroke='currentColor'
                  className='absolute h-[1vh] w-[1vw] -top-[14px] -left-[22px] text-slate-700 stroke-[1px] pointer-events-none'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M12 6v12m6-6H6'
                  />
                </svg>
              ) : null}
            </motion.div>
          ))}
        </motion.div>
      ))}
    </div>
  );
};

export const Boxes = React.memo(BoxesCore);
